/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as S from './Questionnaire.styled';

export default function GeneralInfo() {
    const tableName = 'PersonalInfo';
    const userName = 'User';
    const famMember = 'FamilyMember';
    const spouseFam = 'Spouse';
    const [data, setData] = useState<any>();
    const [user, setUser] = useState<any>();
    const [fam, setFam] = useState<any>();
    const [spouse, setSpouse] = useState<any>();
    const params = useParams();
    const candidate_id = Number(params.id);
    useEffect(() => {
        setData(null);
        setFam(null);
        setSpouse(null);
        api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
        api.tableInput.fetchCandidateInput(setUser, userName, candidate_id);
        api.tableInput.fetchCandidateInput(setSpouse, spouseFam, candidate_id);
        api.tableInput.fetchCandidateInput(setFam, famMember, candidate_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div>
                <span>
                    <S.Title>Applicant</S.Title>
                    <S.Box>
                        <h4>First Name</h4>
                        <h4>Nationality</h4>
                        <S.Value>
                            {user?.firstname} {user?.middlename} {user?.lastname}
                        </S.Value>
                        <S.Value> {data?.nationality}</S.Value>
                        <h4>Date of Birth:</h4>
                        <h4>Gender</h4>
                        <S.Value>{data?.birth_date?.substring(4, 17)}</S.Value>
                        <S.Value>{data?.gender}</S.Value>
                        <h4>Marital Status</h4>
                        <h4>Driver's license</h4>
                        <S.Value>{data?.marital_status}</S.Value>
                        <S.Value>{data?.driver_license}</S.Value>
                        <h4>Country of Residence</h4>
                        <h4>Region of Residence</h4>
                        <S.Value>{data?.country_of_residence}</S.Value>
                        <S.Value>{data?.region_of_residence}</S.Value>
                        <h4>Status of Residence</h4>
                        <h4>Residence since</h4>
                        <S.Value>{data?.residency_status}</S.Value>
                        <S.Value>{data?.residence_since?.substring(4, 17)}</S.Value>
                        <h4>Available funds in {data?.currency}</h4>
                        <h4>Net worth {data?.currency} </h4>
                        <S.Value>
                            {data?.liquid_assets?.toLocaleString(navigator.language, {
                                minimumFractionDigits: 0,
                            })}
                        </S.Value>
                        <S.Value>
                            {data?.net_worth?.toLocaleString(navigator.language, {
                                minimumFractionDigits: 0,
                            })}
                        </S.Value>

                        <h4>Passport number</h4>
                        <h4>Passport validity</h4>
                        <S.Value>{data?.passport_number}</S.Value>
                        <S.Value>{data?.passport_expiration?.substring(4, 17)}</S.Value>
                    </S.Box>
                </span>
                {spouse && (
                    <span style={{ marginTop: '20px' }}>
                        <S.Title>Spouse</S.Title>
                        <S.Box>
                            <h4>First Name</h4>
                            <h4>Nationality</h4>
                            <S.Value>
                                {spouse?.firstname} {spouse?.middlename} {spouse?.lastname}
                            </S.Value>
                            <S.Value> {spouse?.nationality}</S.Value>
                            <h4>Date of Birth:</h4>
                            <h4>Gender</h4>

                            <S.Value>{spouse?.birth_date?.substring(4, 17)}</S.Value>
                            <S.Value>{spouse?.gender}</S.Value>
                            <h4>Country residence</h4>

                            <h4>Residence since</h4>
                            <S.Value>{spouse?.country_of_residence}</S.Value>
                            <S.Value>{spouse?.residence_since?.substring(4, 17)}</S.Value>
                        </S.Box>
                    </span>
                )}
                {fam?.map((item: any, index: number) => (
                    <span key={index}>
                        <S.Title>Family member: N{index + 1}</S.Title>
                        <S.Box>
                            <h4>First Name</h4>
                            <h4>Nationality</h4>
                            <S.Value>
                                {item?.firstname} {item?.middlename} {item?.lastname}
                            </S.Value>
                            <S.Value> {item?.nationality}</S.Value>
                            <h4>Date of Birth:</h4>
                            <h4>Relation</h4>
                            <S.Value>{item?.birth_date?.substring(4, 17)}</S.Value>
                            <S.Value>{item?.relation}</S.Value>

                            <h4>Country residence</h4>
                            <h4 aria-hidden="true"></h4>
                            <S.Value>{item?.country_of_residence}</S.Value>
                        </S.Box>
                    </span>
                ))}
            </div>
        </>
    );
}
